/* ============
 * Vue-ShortKey
 * ============
 *
 * Plugin for VueJS 2.x accepts shortcuts globaly and in a single listener
 *
 * https://github.com/iFgR/vue-shortkey
 */

import Vue from 'vue'

Vue.use(require('vue-shortkey'))



// WEBPACK FOOTER //
// ./src/app/plugins/vue-shortkey.js